import { Coffee } from "lucide-react";

const BMAC_URL = process.env.REACT_APP_BUY_ME_A_COFFEE_URL || "";

export const BuyMeACoffee = () => (
  <section data-testid="buy-me-a-coffee" className="card p-5 flex flex-wrap items-center gap-4 justify-between">
    <p className="text-sm max-w-2xl" style={{ color: "var(--ink-2)" }}>
      <strong className="font-semibold" style={{ color: "var(--ink)" }}>RGA Trainer is completely free to use</strong>, and donations are absolutely not expected. But if you find it useful and feel like shouting a coffee, or chipping in for the hosting costs, it's much appreciated.
    </p>
    {BMAC_URL ? (
      <a data-testid="buy-me-a-coffee-button" href={BMAC_URL} target="_blank" rel="noopener noreferrer"
        className="h-11 px-5 rounded-full font-semibold text-sm flex items-center gap-2 transition-transform hover:-translate-y-0.5"
        style={{ background: "#FFDD00", color: "#0F172A" }}>
        <Coffee size={17} /> Buy me a coffee
      </a>
    ) : (
      <span data-testid="buy-me-a-coffee-button" aria-disabled="true" title="Link coming soon"
        className="h-11 px-5 rounded-full font-semibold text-sm flex items-center gap-2 opacity-60 cursor-not-allowed"
        style={{ background: "#FFDD00", color: "#0F172A" }}>
        <Coffee size={17} /> Buy me a coffee (link coming soon)
      </span>
    )}
  </section>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t mt-10" style={{ borderColor: "var(--line)" }}>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
      <BuyMeACoffee />
      <p className="mt-4 text-xs" style={{ color: "var(--ink-3)" }}>
        RGA Trainer (beta). Not affiliated with, nor endorsed by, any college or other organisation. For use as an adjunct to individual study only.
      </p>
    </div>
  </footer>
);
